<template>
  <div class="gate-wrapper">
    <RadioGroup v-model="selectedGate">
      <Radio
        v-for="gate in order.gates"
        :label="gate.gate_id"
        v-bind:key="gate.gate_id">
      {{$depot.gate(gate.gate_id).name}}
      </Radio>
    </RadioGroup>
    <div class="submit-button">
      <button class="btn primary-button" @click="startLoading">
        {{$t('INDENT_SUBMIT')}}
      </button>
    </div>
  </div>
</template>
<script>
export default {

  props: ['order'],

  data() {
    return {
      selectedGate: null,
    };
  },

  methods: {
    startLoading() {
      // debugger;
    },
  },
};
</script>
<style lang="scss" scoped>

</style>
